import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CustomizedTable, {
  ITableHeader,
} from '../../../components/Table/CustomizedTable';
import useShipmentDiscount from '../../../hooks/useShipmentDiscount';
import { ApplicationState } from '../../../redux/store';

const headers: ITableHeader[] = [
  {
    title: 'Updated Date',
    align: 'left',
    sortable: true,
    column: 'updatedAt',
    type: 'date'
  },
  {
    title: 'Amount',
    align: 'left',
    type: 'currency',
    column: 'amount',
  },
  {
    title: 'Updated By',
    align: 'left',
    type: 'nested',
    column: JSON.stringify(['adminMetadata', 'adminName']),
  },
  {
    title: 'Role',
    align: 'left',
    type: 'nested',
    column: JSON.stringify(['adminMetadata', 'role']),
  },
];

const data: any[] = [
  {
    id: 1,
    updated_at: '20 Jan 2021',
    type: 'Referral Commision',
    amount: 100000,
    updated_by: 'Abang Jago',
    role: 'Admin Finance',
  },
  {
    id: 2,
    updated_at: '20 Jan 2021',
    type: 'Referral Commision',
    amount: 100000,
    updated_by: 'Abang Jago',
    role: 'Admin Finance',
  },
];

export default function ShipmentDiscountHistory() {
  const { logShipmentDiscount } = useSelector((state: ApplicationState) => state.masterDataReferral)

  const [page, setPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [query, setQuery] = useState({ limit: 25, offset: 0, search: '' });

  const { fetchLogShipmentDiscount } = useShipmentDiscount()

  useEffect(() => {
    fetchLogShipmentDiscount(query)
  }, [query])

  useEffect(() => {
    if (logShipmentDiscount.payload.count > 0) {
      setTotalData(logShipmentDiscount.payload.count)
      setTotalPage(Math.ceil(logShipmentDiscount.payload.count / rowsPerPage))
    }
  }, [logShipmentDiscount.payload])

  function changePagination(value: number) {
    setPage(value)
    setQuery((oldVal: any) => {
      return {
        ...oldVal,
        offset: (value - 1) * rowsPerPage,
        limit: rowsPerPage
      }
    })
  }

  function changeRowsPerPage(value: number) {
    setRowsPerPage(value)
    setPage(1)
    setQuery((oldVal: any) => {
      return {
        ...oldVal,
        offset: 0,
        limit: value
      }
    })
  }

  return (
    <CustomizedTable
      data={logShipmentDiscount.payload.results}
      headers={headers}
      totalData={totalData}
      page={page}
      totalPage={totalPage}
      rowsPerPage={rowsPerPage}
      onChange={(newPage) => changePagination(newPage)}
      onRowsPerPageChange={(value: any) => changeRowsPerPage(value)}
    />
  );
}
